import {toast} from '@wandb/weave/common/components/elements/Toast';
import copyToClipboard from 'copy-to-clipboard';

export function copyWithToast(text: string, toastText: string): void {
  copyToClipboard(text);
  toast(toastText);
}
